export default __webpack_public_path__ + "static/media/meins box_Brief.7582a4ce.PNG";